<template>
    <div class="different">
        <h1>Things Make It Different</h1>
        <p>Wizy does its best to fit every customer and provides many solutions for it.</p>
        <div class="wrapper">
            <div class="thing">
                <div class="span-wrapper"><span class="icon-emoticon"/></div>
                <h2>Simple</h2>
                <p>Wizy is simple. Do what you want with one click without hidden 'buttons' or ways to do something.</p>
            </div>
            <div class="thing">
                <div class="span-wrapper"><span class="icon-secure"/></div>
                <h2>Secure</h2>
                <p>Wizy is PCI compliant and makes the data secure and encrypted.</p>
            </div>
            <div class="thing">
                <div class="span-wrapper"><span class="icon-meter"/></div>
                <h2>High Performance</h2>
                <p>In various Benchmark tests our App is above the average. Even on Android we managed to have one of the greatest perfomance available.</p>
            </div>
            <div class="thing">
                <div class="span-wrapper"><span class="icon-cloud"/></div>
                <h2>Lorem Ipsum</h2>
                <p>Lorem Ispum dolor set amet</p>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: "Fact",
  props: []
};
</script>

<style lang="scss" scoped>
.different{
   background-color: rgb(246,249,254);
   margin-bottom: 10%;
   h1{
        font-size: 2rem;
        font-weight: bold;
        text-align: center;
        margin-top: 5%;
        padding: 5% 0 1% 0;
   }
   p{
    color: rgb(107,115,122);
    margin-bottom: 5%;
    font-weight: 500;
    text-align: center;
   }
   .wrapper{
       text-align: center;
       padding-bottom: 5%;
       .thing{
           vertical-align: top;
           display: block;
           width: 80%;
           margin: 0 auto;
           @media(min-width: 780px){
               width: 20%;
               display: inline-block;
           }
           .span-wrapper{
               margin: 10%;
               span{
                color: rgb(54,209,220);
                font-size: 3.5rem;
               }
           }
           h2{
               font-size: 1.5rem;
               font-weight: bold;
               color: rgb(81,86,93);
           }
           p{

           }
       }
   }
}
</style>
